import * as React from 'react';

import PropTypes from 'prop-types';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/NotifyOption';

class NotifyOption extends React.Component {
  static propTypes = {
    dontNotify: PropTypes.bool.isRequired,
    toggleNotify: PropTypes.func.isRequired,
  };

  render() {
    return (
      <div className="rc-NotifyOption">
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'dontNotify' does not exist on type 'Read... Remove this comment to see the full error message */}
        <input id="notify" type="checkbox" checked={!this.props.dontNotify} onChange={this.props.toggleNotify} />
        <label htmlFor="notify" className="color-secondary-text">
          {_t('Notify Original Poster')}
        </label>
      </div>
    );
  }
}

export default NotifyOption;
